import { configureStore } from '@reduxjs/toolkit';
import uiReducer from '@features/ui/UiSlice';
import { apiSearchSlice } from '@features/api/apiSearchSlice';
import { apiCommunitySlice } from '@features/api/apiCommunitySlice';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    [apiSearchSlice.reducerPath]: apiSearchSlice.reducer,
    [apiCommunitySlice.reducerPath]: apiCommunitySlice.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([apiSearchSlice.middleware, apiCommunitySlice.middleware]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
